import { render, staticRenderFns } from "./top-posts-story.vue?vue&type=template&id=202c2e12&scoped=true&"
import script from "./top-posts-story.vue?vue&type=script&lang=js&"
export * from "./top-posts-story.vue?vue&type=script&lang=js&"
import style0 from "./top-posts-story.vue?vue&type=style&index=0&id=202c2e12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202c2e12",
  null
  
)

export default component.exports